import {
  GET_REPORT_BUILDER_FIELDS_REQUEST,
  GET_REPORT_BUILDER_FIELDS_SUCCESS,
  GET_REPORT_BUILDER_FIELDS_ERROR,
} from '../../actions'
import { IDLE, FETCHED, FETCHING, FAILED } from '../../constants/fetchStates'

const initial = {
  data: [],
  status: IDLE
}

const reportBuilderFields = (state = initial, action) => {
  switch (action.type) {
    case GET_REPORT_BUILDER_FIELDS_REQUEST:
      return {
        ...state,
        status: FETCHING
      }
    case GET_REPORT_BUILDER_FIELDS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: FETCHED
      }
    case GET_REPORT_BUILDER_FIELDS_ERROR:
      return {
        ...state,
        status: FAILED
      }
    default:
      return state
  }
}

export default reportBuilderFields
